import "antd/es/input/style";
import _Input from "antd/es/input";
/**
 * Group组件
 */

var SuiGroup = _Input.Group;
export default SuiGroup;